import React, { useState, useEffect, useRef } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Modal,
  TextInput,
} from "react-native";

import { v4 as uuidv4 } from "uuid";

import { useTranslation } from "react-i18next";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";

import { observer, Observer } from "mobx-react";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";

const ClientFeePlanView = ({ isVisible, onClose, client }) => {
  const { t } = useTranslation();
  const { screenWidth, screenHeight, ultraWideScreen } = useScreenDimensions();
  const [feeIsVoid, setFeeIsVoid] = useState(false);
  const { isMobile } = useDevice();

  const [feeInput, setFeeInput] = useState(
    client.lastFee
      ? client.lastFee.fee !== 0
        ? client.lastFee.fee.toString()
        : ""
      : ""
  );

  const handleBlurFee = () => {
    // Convert the input text to a number on blur
    if (feeInput === "") {
      // client.setProperty("clientFee", 0);
    } else {
      const fee = parseFloat(feeInput);
      if (!isNaN(fee)) {
        //   client.setProperty("clientFee", fee);
      } else {
        // If the input is not a valid number, revert to the last valid clientFee
        setFeeInput(client.lastFee ? client.lastFee.fee.toString() : "");
      }
    }
  };

  const changeFee = (text) => {
    // Only update the state if the text is a valid number or empty
    if (/^\d*\.?\d*$/.test(text)) {
      setFeeInput(text);
    }
  };

  const [feeTypeMenu, setFeeTypeMenu] = useState(false);
  const showFeeTypeMenu = () => setFeeTypeMenu(true);

  const [feeType, setFeeType] = useState(
    client.lastFee ? client.lastFee.fee_type : "Mensual"
  );

  const action = (quota) => {
    setFeeType(quota);
    setFeeTypeMenu(false);
  };

  const inputRef = useRef(null);

  const [isEditing, setIsEditing] = useState(false);
  const today = new Date();
  const [newDay, setNewDay] = useState(
    client.lastFee
      ? client.lastFee.fee_start_date_day.toString()
      : today.getDate().toString()
  );
  const [newMonth, setNewMonth] = useState(
    client.lastFee
      ? client.lastFeeEndDateParts("Month").toString()
      : String(today.getMonth() + 1)
  );
  const [newYear, setNewYear] = useState(
    client.lastFee
      ? client.lastFeeEndDateParts("Year").toString()
      : today.getFullYear().toString()
  );
  const dayInputRef = useRef(null);
  const monthInputRef = useRef(null);
  const yearInputRef = useRef(null);

  useEffect(() => {
    if (isEditing) {
      const timer = setTimeout(() => {
        dayInputRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isEditing]);

  const handleTextChange = (text, part) => {
    let newText = text.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    let newValue = newText ? parseInt(newText, 10) : "";

    if (part === "day") {
      if (newValue < 1 || newValue > 31) {
        setNewDay(""); // Reset if day is invalid
      } else {
        setNewDay(newValue.toString());
      }
    } else if (part === "month") {
      if (newValue < 1 || newValue > 12) {
        setNewMonth(""); // Reset if month is invalid
      } else {
        setNewMonth(newValue.toString());
      }
    } else if (part === "year") {
      setNewYear(newValue.toString()); // Directly update year without further validation here
    }

    if (newValue.toString().length === 2 && part !== "year") {
      if (part === "day") {
        monthInputRef.current?.focus();
      } else if (part === "month") {
        yearInputRef.current?.focus();
      }
    }
  };

  const handleBlurDate = () => {
    setTimeout(() => {
      if (
        document.activeElement !== dayInputRef.current &&
        document.activeElement !== monthInputRef.current &&
        document.activeElement !== yearInputRef.current
      ) {
        setIsEditing(false);
      }
    }, 10);
  };

  const handleTextClick = () => {
    setIsEditing(true);
  };

  const Cancel = () => {
    // coach.setSearchTerm("");
    client.setProperty("selectedToRenew", false);
    onClose();
  };
  const Save = () => {
    const payment = {
      id: uuidv4().toLowerCase(),
      fee: feeInput,
      fee_type: feeType,
      fee_start_date_day: Number(newDay),
      fee_start_date_month: Number(newMonth),
      fee_start_date_year: Number(newYear),
    };
    if (feeInput !== "") {
      // console.log("Added to client's payment history: ", payment);
      client.feeHistory.push(payment);
      client.uploadData({
        fee_history: client.sortedFeeHistory,
      });
      Cancel();
    } else {
      setFeeIsVoid(true);
    }
  };
  const Buttons = ({ bool }) => {
    const text = bool ? "renew-string" : "cancel-string";

    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={bool ? Save : Cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: bool ? Colors.bubbleColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: bool ? Colors.bubbleColor : "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            marginHorizontal: !bool && 10,
            opacity: isHovered ? 0.8 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: bool ? Colors.whiteColor : "red",
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const EndDate = observer(() => {
    const feeTypeIndex =
      feeType === "Trimestral"
        ? 3
        : feeType === "Semestral"
        ? 6
        : feeType === "Anual"
        ? 12
        : 1;
    const endMonthIndex = Number(newMonth) + feeTypeIndex;

    const endMonthReturn =
      endMonthIndex > 12 ? endMonthIndex - 12 : endMonthIndex;

    const endYearReturn = endMonthIndex > 12 ? Number(newYear) + 1 : newYear;

    return (
      <Text
        style={{
          width: "100%",
          color: Colors.grayColor,
          textAlign: "center",
          fontSize: 12,
          marginBottom: 20,
        }}
      >
        {/* El siguiente pago será: {newDay} / {endMonthReturn} / {endYearReturn} */}
        {t("nextPaymentWillBe-string", {
          newDay: newDay,
          endMonthReturn: endMonthReturn,
          endYearReturn: endYearReturn,
        })}
      </Text>
    );
  });

  const MenuItemView = ({ idx }) => {
    const [isHovered, setIsHovered] = useState(false);

    return idx === 1 ? (
      <MenuItem
        onPress={() => action("Mensual")}
        style={{ minWidth: 110 }}
        textStyle={{
          fontSize: 14,
          fontWeight: isHovered ? "600" : "normal",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("Mensual")}
      </MenuItem>
    ) : idx === 2 ? (
      <MenuItem
        onPress={() => action("Trimestral")}
        style={{ minWidth: 110 }}
        textStyle={{
          fontSize: 14,
          fontWeight: isHovered ? "600" : "normal",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("Trimestral")}
      </MenuItem>
    ) : idx === 3 ? (
      <MenuItem
        onPress={() => action("Semestral")}
        style={{ minWidth: 110 }}
        textStyle={{
          fontSize: 14,
          fontWeight: isHovered ? "600" : "normal",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("Semestral")}
      </MenuItem>
    ) : (
      <MenuItem
        onPress={() => action("Anual")}
        style={{ minWidth: 110 }}
        textStyle={{
          fontSize: 14,
          fontWeight: isHovered ? "600" : "normal",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("Anual")}
      </MenuItem>
    );
  };

  const [isFeeHovered, setIsFeeHovered] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);
  const [isDateHovered, setIsDateHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={Cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={Cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={[styles.modalView, { padding: 24 }]}>
            <Text style={[Fonts.bold16, {}]}>
              {t("renewClientsQuota-string", { name: client.nameForCoach })}
            </Text>

            <View
              style={[
                GlobalStyles.HStack,
                {
                  alignItems: "center",
                  width: "100%",
                  marginVertical: 16,
                },
              ]}
            >
              <Text
                style={[
                  Fonts.regular14,
                  {
                    color: "black",
                    textAlign: "center",
                    marginBottom: 1,
                    marginRight: 20,
                  },
                ]}
              >
                {t("feeDots-string")}
              </Text>
              <View style={GlobalStyles.Spacer} />
              <TextInput
                ref={inputRef}
                placeholder=""
                placeholderTextColor={"gray"}
                onBlur={handleBlurFee}
                value={feeInput} // Bind the input value to the local state
                onChangeText={changeFee}
                style={{
                  borderColor: isFeeHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                  borderRadius: 10,
                  borderWidth: 0.5,
                  color: "black",
                  textAlign: "center",
                  fontSize: 14,
                  padding: 4,
                  width: 60,
                }}
                inputMode="numeric" // Set keyboard type to numeric to show numeric keypad
                maxLength={50}
                onMouseEnter={() => !isMobile && setIsFeeHovered(true)}
                onMouseLeave={() => setIsFeeHovered(false)}
              />
              <Text
                style={[
                  Fonts.regular14,
                  {
                    color: "black",
                    textAlign: "center",
                    marginLeft: 5,
                  },
                ]}
              >
                {t("currency-string")}
              </Text>
            </View>

            <View
              style={[
                GlobalStyles.HStack,
                {
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginBottom: 20,
                },
              ]}
            >
              <Text
                style={[
                  Fonts.regular14,
                  {
                    color: "black",
                    textAlign: "center",
                    marginBottom: 1,
                    marginRight: 20,
                  },
                ]}
              >
                {t("quotaTypeDots-string")}
              </Text>
              <Menu
                visible={feeTypeMenu}
                anchor={
                  <Text
                    onPress={showFeeTypeMenu}
                    style={[
                      Fonts.regular14,
                      {
                        textAlign: "center",
                        textAlignVertical: "center",
                        color: Colors.blackColor,
                        fontWeight: isMenuHovered ? "600" : "normal",
                      },
                    ]}
                    onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                    onMouseLeave={() => setIsMenuHovered(false)}
                  >
                    {t(feeType)}
                  </Text>
                }
                style={[GlobalStyles.menu, { marginVertical: 16 }]}
                onRequestClose={() => setFeeTypeMenu(false)}
              >
                <MenuItemView idx={1} />
                <MenuItemView idx={2} />
                <MenuItemView idx={3} />
                <MenuItemView idx={4} />
              </Menu>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: 20,
              }}
            >
              <Text
                style={{
                  color: "black",
                  textAlign: "center",
                  marginBottom: 1,
                  marginRight: 20,
                }}
              >
                {t("beginningOfQuotaDots-string")}
              </Text>
              {isEditing ? (
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    ref={dayInputRef}
                    onBlur={handleBlurDate}
                    style={{ width: 25, textAlign: "center", fontSize: 14 }}
                    inputMode="numeric"
                    maxLength={2}
                    onChangeText={(text) => handleTextChange(text, "day")}
                    value={newDay}
                    placeholder="DD"
                    placeholderTextColor={Colors.grayColor}
                    returnKeyType="next"
                    onSubmitEditing={() => monthInputRef.current?.focus()}
                  />
                  <Text style={{ marginHorizontal: 2 }}>/</Text>
                  <TextInput
                    ref={monthInputRef}
                    onBlur={handleBlurDate}
                    style={{ width: 25, textAlign: "center", fontSize: 14 }}
                    inputMode="numeric"
                    maxLength={2}
                    onChangeText={(text) => handleTextChange(text, "month")}
                    value={newMonth}
                    placeholder="MM"
                    placeholderTextColor={Colors.grayColor}
                    returnKeyType="next"
                    onSubmitEditing={() => yearInputRef.current?.focus()}
                  />
                  <Text style={{ marginHorizontal: 2 }}>/</Text>
                  <TextInput
                    ref={yearInputRef}
                    onBlur={handleBlurDate}
                    style={{ width: 35, textAlign: "center", fontSize: 14 }}
                    inputMode="numeric"
                    maxLength={4}
                    onChangeText={(text) => handleTextChange(text, "year")}
                    value={newYear}
                    placeholder="YYYY"
                    placeholderTextColor={Colors.grayColor}
                  />
                </View>
              ) : (
                <Text
                  onPress={handleTextClick}
                  style={{
                    color: "black",
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: isDateHovered ? "600" : "normal",
                  }}
                  onMouseEnter={() => !isMobile && setIsDateHovered(true)}
                  onMouseLeave={() => setIsDateHovered(false)}
                >
                  {newDay} / {newMonth} / {newYear}
                </Text>
              )}
            </View>

            <EndDate />

            {feeIsVoid && (
              <Text
                style={[Fonts.regular14, { marginBottom: 20, color: "red" }]}
              >
                {t("feeIsVoid-string")}
              </Text>
            )}

            <View
              style={{
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Buttons bool={true} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    width: 300,
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
});

export default ClientFeePlanView;
